import React, {Component} from "react"
import logo from './logo.png'
import arrow from './arrow.png'
import cross from './cross.png'

export class RetailSummit2021 extends Component {
  render() {
    let {data, screen} = this.props;

    let background = '#000';
    if (screen === 'enterState') {
      background = '#00a01e'
    } else if (screen === 'waitState') {
      background = '#ff771c'
    } else {
      document.body.style.backgroundColor = background;
      return <div />;
    }

    document.body.style.backgroundColor = background;

    return (
      <div className='text-light'>
        <div style={{paddingTop: '16vh', paddingLeft: '16vh'}}>
          <img style={{height: '3vh'}} src={logo} alt="Pygmalios" className="app-logo"/>
          <div style={{
            position: 'relative',
            fontSize: '30vh',
            fontWeight: 'bold',
            paddingTop: '13vh',
            left: '-1vw',
            lineHeight: 1}}
          >
            {screen === 'enterState' ? 'Enter' : 'Stop'}
          </div>
          <div style={{lineHeight: 1, paddingTop: '5vh', position: 'relative', left: '-0.5vw'}}>
            <span style={{fontSize: '15vh', fontWeight: 'bold'}}>{data.currentOccupancy}</span>
            <span style={{fontSize: '8vh', opacity: 0.6}}> / {data.maxOccupancy} míst</span>
          </div>
          <div style={{fontSize: '4vh', fontWeight: 'bold'}}>OBSAZENOST HLAVNÍHO SÁLU</div>
        </div>
        <img style={{width: '32vw', position: 'absolute', top: '21vh', left: '71vw'}}
             src={screen === 'enterState' ? arrow : cross}
        />
        {screen === 'waitState' &&
        <div style={{fontSize: '4vw', fontWeight: 'bold', position: 'absolute', top: '36vh', left: '63vw'}}>Plná kapacita</div>
        }
      </div>
    )
  }
}
